import styled from '@emotion/styled'

export const StyledLoading = styled.div`

    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;

`